import { all, put, takeLatest, getContext, call, select } from 'redux-saga/effects';

import { Logger } from '../../utils/Logger';
import { Analytics } from '../../utils/Analytics';

import { ME_REQUEST, patchUserPreferences } from './types';
import { LOGIN_SUCCESS } from '../auth/types';
import listSaga from './list/sagas';
import marketplaceSaga from './marketplace/sagas';
import signupSaga from './signup/sagas';
import networkSignupSaga from './networkSignup/sagas';
import onboardingSaga from './onboarding/sagas';
import openIdSignupSaga from './openIdSignup/sagas';

import { meSuccess, meFailure } from './reducer';
import { makeSelectMasquerade } from 'reducers/auth/selectors';

const logger = new Logger('Saga:User');

export function* getLoggedUserInfo() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(routerService.generate('api.platform.me'));

    logger.info('Updated logged user information');

    const masquerade = yield select(makeSelectMasquerade());

    Analytics.setUserInfo({ ...response.data, masquerade });
    yield put(meSuccess(response.data));
  } catch (error) {
    logger.info('Failed to Updated logged user information');
    yield put(meFailure(error));
  }
}

export function* patchUserPreferencesOption(action) {
  const { key, value } = action;
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    yield call(authApiService.patch, routerService.generate('api.user_preferences'), {
      key,
      value,
    });
  } catch (error) {
    logger.error('Failed to complete set user preference option ', error);
  }
}

export default function* userSaga() {
  return yield all([
    takeLatest(ME_REQUEST, getLoggedUserInfo),
    takeLatest(LOGIN_SUCCESS, getLoggedUserInfo),
    listSaga(),
    marketplaceSaga(),
    signupSaga(),
    networkSignupSaga(),
    onboardingSaga(),
    openIdSignupSaga(),
    takeLatest(patchUserPreferences.request, patchUserPreferencesOption),
  ]);
}
